import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { teal } from "@mui/material/colors";
import React, { useState } from "react";
import { colors } from "../../data/Filter/color";
import { price } from "../../data/Filter/price";
import { discount } from "../../data/Filter/discount";
import { useSearchParams } from "react-router-dom";

export const FilterSection = () => {
  const [expandColor,setExpandColor]= useState(false);
  const [expandDiscount, setExpandDiscount]=useState(false)
  const [searchParams, setSearchParams]= useSearchParams();
  const updateFilterParams =(e:React.ChangeEvent<HTMLInputElement>)=>{
//     If value is truthy (meaning it's not empty or null), the function sets the search parameter with the given name to the value using searchParams.set(name, value).
// If value is falsy (meaning the input is empty or cleared), the function deletes the search parameter associated with the name using searchParams.delete(name).
      const {value,name}= e.target;
      if(value){
        searchParams.set(name,value)
      }else{
        searchParams.delete(name);
      }
      setSearchParams(searchParams)

  }
  const clearAllFilter=()=>{
    // searchParams.forEach((value:any,key:any)=>{
    //   searchParams.delete(key);
    // })
    // setSearchParams(searchParams)
    const newSearchParams = new URLSearchParams();
  
  // Set the updated (empty) search parameters
//   All Keys Are Removed: Creating a new URLSearchParams object effectively clears all existing parameters. It does not retain any keys or values from the previous searchParams object.
// No Data Is Stored: The old keys and values are not stored or retained anywhere. By replacing searchParams with the newly created empty object, all query parameters are removed from the URL, and any reference to the old parameters is discarded.
  setSearchParams(newSearchParams);
  }
  const handleColorToggle=()=>{
      setExpandColor(!expandColor)
  }
  const handleDiscountToggle = () => { 
    setExpandDiscount(!expandDiscount)
   }
  return (
    <div className="-z-50 space-y-5 bg-white">
      <div className="flex items-center justify-between h-[40px] px-9 lg:border-r">
        <p className="text-lg font-semibold">Filters</p>
        <Button
        onClick={clearAllFilter}
          size="small"
          className="text-teal-600 cursor-pointer font-semibold"
        >
          Clear All
        </Button>
      </div>
      <Divider />
      <div className="px-7 space-y-6">
        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                color: teal[500],
                paddingBottom: "14px",
              }}
              className="text-2xl font-semibold"
              id="color"
            >
              Color
            </FormLabel>
            <RadioGroup onChange={updateFilterParams} aria-labelledby="color" defaultValue="" name="color">
              {colors.slice(0,expandColor?colors.length:5).map((item,index) => (
                <FormControlLabel
                key={index}
                  value={item.name}
                  control={<Radio />}
                  label={
                    <div className="flex items-center gap-3">
                      <p>{item.name}</p>
                      <p
                        style={{ backgroundColor: item.hex }}
                        className={`h-5 w-5 rounded-full ${
                          item.name === "White" ? "border" : ""
                        }`}
                      ></p>
                    </div>
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
          <div className="text-primary cursor-pointer hover:text-teal-900 flex items-center">
            <button onClick={handleColorToggle}>
             { expandColor?"hide":`+${colors.length-5} more`}
            </button>
          </div>
        </section>
        <Divider/>
        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                color: teal[500],
                paddingBottom: "14px",
              }}
              className="text-2xl font-semibold"
              id="price"
            >
              Price
            </FormLabel>
            <RadioGroup onChange={updateFilterParams} aria-labelledby="price" defaultValue="" name="price">
              {price.map((item,index) => (
                <FormControlLabel
                value={`${item.min}-${item.max ?? ""}`}
                  key={item.name}
                  control={<Radio size="small" />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </section>
        <Divider/>
        <section>
          <FormControl>
            <FormLabel
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                color: teal[500],
                paddingBottom: "14px",
              }}
              className="text-2xl font-semibold"
              id="brand"
            >
             Discount
            </FormLabel>
            {/* So, name is a constant identifier for the group ("discount"), and value dynamically comes from the discount data you are iterating over. */}
            <RadioGroup onChange={updateFilterParams} aria-labelledby="brand" defaultValue="" name="minDiscount">
              {discount.slice(0,expandDiscount?discount.length:5).map((item) => (
                <FormControlLabel
                  value={item.value}
                  key={item.name}
                  control={<Radio />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </FormControl>
          <div className="text-primary cursor-pointer hover:text-teal-900 flex items-center">
            <button onClick={handleDiscountToggle}>
             { expandDiscount?"hide":`+${discount.length-5} more`}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};
